import { AxiosError } from 'axios';
import { v4 as uuid } from 'uuid';
import { restErrorsToForm } from '../../../utils/restErrorToForm';
import { useHistory } from '../../../hooks/useHistory';
import { useUtcomApi } from '../../../hooks/useUtcomApi';
import { FormValues } from '.';

// t('exceptions:com-unitedtraders-luna-utexbridge-exception-InsufficientFundsException')
export const useSubmit = () => {
  const utcomApi = useUtcomApi();
  const history = useHistory();

  const onSubmit = async (values: FormValues) => {
    try {
      await utcomApi.depositService.depositFromUtex({
        requestId: uuid(),
        amount: { value: values.amount, currency: 'USD' },
      });
      history.push('/success');
      return;
    } catch (e: AxiosError | any) {
      return restErrorsToForm(e.response?.data || e, 'amount');
    }
  };

  return {
    onSubmit,
  };
};
